import type { ReactNode } from 'react';
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context';

import { useAuthProvider } from 'src/hooks/useAuthProvider';

type Props = {
  children: ReactNode;
};

export const AuthProvider = ({ children }: Props) => {
  const { onSigninCallback, userManager } = useAuthProvider();

  return (
    <OidcAuthProvider
      onSigninCallback={onSigninCallback}
      userManager={userManager}
    >
      {children}
    </OidcAuthProvider>
  );
};
